import { render, staticRenderFns } from "./visitlocationaddress.vue?vue&type=template&id=128b1244"
import script from "./visitlocationaddress.vue?vue&type=script&lang=js"
export * from "./visitlocationaddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports